/**
 * Account admin barrel aggregator
 * Combines all account-related handlers (Accounts, Organizations, Workspaces, Users)
 */

import type { UseAdminAppReturn } from "./useAdminApp";
import type { PSAuthConfig } from "@pineseed/workspace/handlers/auth-handler";
import { useAccountsAdmin, type AccountsAdminHandler } from "./account/useAccountsAdmin";
import { useOrganizationsAdmin, type OrganizationsAdminHandler } from "./account/useOrganizationsAdmin";
import { useWorkspacesAdmin, type WorkspacesAdminHandler } from "./account/useWorkspacesAdmin";
import { useUsersAdmin, type UsersAdminHandler } from "./account/useUsersAdmin";

export interface AccountAdminHandler {
  accounts: AccountsAdminHandler;
  organizations: OrganizationsAdminHandler;
  workspaces: WorkspacesAdminHandler;
  users: UsersAdminHandler;
}

export function useAccountAdmin(
  adminApp: UseAdminAppReturn,
  authConfig: PSAuthConfig
): AccountAdminHandler {
  const accounts = useAccountsAdmin(adminApp);
  const organizations = useOrganizationsAdmin(adminApp);
  const workspaces = useWorkspacesAdmin(adminApp);
  const users = useUsersAdmin(adminApp, authConfig);

  return {
    accounts,
    organizations,
    workspaces,
    users,
  };
}

// Re-export types for convenience
export type { AccountsAdminHandler, OrganizationsAdminHandler, WorkspacesAdminHandler, UsersAdminHandler };

